/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Lot_Debt_Confirm_LabelInputs */

const vi_pos_lot_debt_confirm_label = /** @type {(inputs: Pos_Lot_Debt_Confirm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận bán nợ lô`)
};

/**

* @param {Pos_Lot_Debt_Confirm_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_debt_confirm_label = /** @type {((inputs?: Pos_Lot_Debt_Confirm_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_Debt_Confirm_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_debt_confirm_label(inputs)
});